import { useTranslation } from "react-i18next"
import { graphql, useFragment } from "react-relay"
import { TooltipContent, TooltipCustom, TooltipPortal, TooltipTrigger } from "@/components/ui/tooltip"
import { AddressLink } from "@/modules/patients/components/address-link"
import { patientAddressTooltip_Address$key } from "@/modules/patients/components/patient-info/__generated__/patientAddressTooltip_Address.graphql"
import { PatientFragment$data } from "@/modules/patients/services/__generated__/PatientFragment.graphql"

const patientAddressTooltipFragment = graphql`
  fragment patientAddressTooltip_Address on Address {
    city
    country {
      id
      code: countryIsoCode2
      countryLookupTranslations {
        countryIsoCode2
        countryName
        language
      }
    }
    houseNumberStreet
    postalCode
    countryCode
  }
`

export const PatientAddressTooltip = ({
  addressKey,
  patientAddress,
}: {
  addressKey?: patientAddressTooltip_Address$key | null
  patientAddress: PatientFragment$data["address"]
}) => {
  const { t } = useTranslation()
  const appointmentAddress = useFragment(patientAddressTooltipFragment, addressKey)
  const address = appointmentAddress || patientAddress
  const hasManuallyAddedAddress = !!appointmentAddress
  return (
    address && (
      <TooltipCustom>
        <TooltipTrigger>
          <AddressLink address={address} hasManuallyAddedAddress={hasManuallyAddedAddress} />
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent side="top" align="start">
            {t("patient.header.openGoogleMaps")}
          </TooltipContent>
        </TooltipPortal>
      </TooltipCustom>
    )
  )
}
